/* Pilatoes search as you type (PLAN-search-empty.md, approved 27 Oct 2026).
   Enhances the existing /search field (blocks/_search-input.liquid): rows come from sections/pilatoes-search-suggest.liquid
   via the Section Rendering API on routes.predictive_search_url. ARIA 1.2 combobox + listbox; debounce 150 ms.
   Without JS, or when a request fails, the field submits the normal search. */
(function () {
  var input = document.querySelector('search-page-input-component .search-page-input');
  if (!input || input.dataset.pltSug) return;
  input.dataset.pltSug = '1';
  var host = input.closest('search-page-input-component');
  var url = (window.Theme && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';

  var list = document.createElement('ul');
  list.id = 'plt-sug-list';
  list.className = 'plt-sug';
  list.setAttribute('role', 'listbox');
  list.hidden = true;
  var live = document.createElement('p');
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  host.appendChild(list);
  host.appendChild(live);

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', list.id);
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('autocomplete', 'off');

  var timer = 0, ctrl = null, active = -1, last = '';
  var rows = function () { return Array.prototype.slice.call(list.querySelectorAll('.plt-sug__row')); };

  function setActive(i) {
    var r = rows();
    r.forEach(function (el, k) { el.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    active = i;
    if (i >= 0 && r[i]) {
      input.setAttribute('aria-activedescendant', r[i].id);
      r[i].scrollIntoView({ block: 'nearest' });
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }
  function close() {
    if (ctrl) { ctrl.abort(); ctrl = null; }
    clearTimeout(timer);
    list.hidden = true;
    list.classList.remove('is-open');
    input.setAttribute('aria-expanded', 'false');
    setActive(-1);
  }
  function open() {
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { list.classList.add('is-open'); });
  }
  function fetchRows(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var u = new URL(url, location.origin);
    u.searchParams.set('q', q);
    u.searchParams.set('resources[type]', 'product');
    u.searchParams.set('resources[limit]', '6');
    u.searchParams.set('section_id', 'pilatoes-search-suggest');
    fetch(u.toString(), { signal: ctrl.signal })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (input.value.trim() !== q) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-plt-sug]');
        if (!src) { close(); return; }
        list.setAttribute('aria-label', src.dataset.label || '');
        list.innerHTML = src.innerHTML;
        live.textContent = src.dataset.status || '';
        setActive(-1);
        open();
      })
      .catch(function (e) { if (e.name !== 'AbortError') close(); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { last = ''; close(); return; }
    if (q === last && !list.hidden) return;
    timer = setTimeout(function () { last = q; fetchRows(q); }, 150);
  });

  input.addEventListener('keydown', function (e) {
    var r = rows();
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (list.hidden || !r.length) return;
      e.preventDefault();
      var d = e.key === 'ArrowDown' ? 1 : -1;
      setActive(active < 0 ? (d > 0 ? 0 : r.length - 1) : (active + d + r.length) % r.length);
    } else if (e.key === 'Enter') {
      if (!list.hidden && active >= 0 && r[active]) {
        e.preventDefault();
        var a = r[active].querySelector('a');
        if (a) location.href = a.href;
      }
    } else if (e.key === 'Escape') {
      if (!list.hidden) { close(); }
    } else if (e.key === 'Tab') {
      close();
    }
  });

  /* keep focus in the field while a row is tapped; the link then opens the product */
  list.addEventListener('pointerdown', function (e) { e.preventDefault(); });
  list.addEventListener('mousemove', function (e) {
    var row = e.target.closest('.plt-sug__row');
    if (row) setActive(rows().indexOf(row));
  });
  input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) close(); }, 0); });
  document.addEventListener('pointerdown', function (e) { if (!host.contains(e.target)) close(); });
})();
